import React, {useState} from "react";
import './SidebarMobile.scss';
import './Sidebar.css';
import {useAuthState} from "../../context/AuthContext";
import {CollapsedSidebar} from "@moeindal/base-raiko-panel-components";
import {advanceSidebarItems} from "./SideBarItems";
import brandLogo from "../../../src/assets/images/log_1.png";
import RaikoDrawer, {RaikoDrawerDirection} from "../../raikoComponents/raikoDrawer/RaikoDrawer.tsx";

const SidebarMobile = () => {
    const {role: roles = []} = useAuthState();

    const [openSidebarMobile, setOpenSidebarMobile] = useState(false)


    function handleOpenSidebarMobile() {
        setOpenSidebarMobile(true)
    }

    function handleCloseSidebarMobile() {
        setOpenSidebarMobile(false)
    }


    return (
        <div className="header-content">
            <div className="ic-menu" onClick={handleOpenSidebarMobile}/>
            <RaikoDrawer
                openDrawer={openSidebarMobile}
                onClose={handleCloseSidebarMobile}
                onOpen={handleOpenSidebarMobile}
                anchor={RaikoDrawerDirection.RIGHT}
            >
                <CollapsedSidebar
                    advanceSidebarItems={advanceSidebarItems}
                    roles={roles}
                    hasBrand
                    brandTitle={"دیار مرد میدان"}
                    brandImage={brandLogo}
                    brandUrlAddress={"https://dmmkr.ir/"}
                />
            </RaikoDrawer>
        </div>
    )
}
export default SidebarMobile;